module.exports = {
      id: "double-arrow-usage",
      viewBox: "0 0 21.133 19.508",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#double-arrow",
      toString: function () {
        return this.url;
      }
    }